import { isValidDataFormatForField } from '../constants/data_view.constants';
import { toSnakeCase } from './utils';
/**
 * Merges a preview/form dimension into an existing DimensionDefinition (SSP-4237).
 * Preserves Data settings (title, description, format, public) for columns that still exist.
 * Resets format only when the type change makes the current format invalid.
 */
export const mergeDimensionFromPreview = (existing, incoming) => {
    if (!existing) {
        return {
            sql: incoming.sql,
            type: incoming.type,
            title: incoming.title || incoming.name,
            ...(incoming.description !== undefined ? { description: incoming.description } : {}),
        };
    }
    const nextType = incoming.type || existing.type;
    const nextDescription = incoming.description !== undefined ? incoming.description : existing.description;
    const merged = {
        ...existing,
        sql: incoming.sql,
        type: nextType,
        title: existing.title || incoming.title || incoming.name,
    };
    if (nextDescription !== undefined) {
        merged.description = nextDescription;
    }
    else {
        delete merged.description;
    }
    // Drop format when the (possibly updated) type no longer allows it.
    if (!isValidDataFormatForField('Dimension', nextType, merged.format)) {
        delete merged.format;
    }
    return merged;
};
/**
 * Builds the dimensions map for an SQL edit save: keeps metadata for matching keys,
 * adds new columns from the preview, and drops columns no longer present.
 */
export const mergeDimensionsFromPreview = (existingDimensions, incomingDimensions) => {
    const updated = {};
    for (const dimension of incomingDimensions) {
        const dimensionKey = toSnakeCase(dimension.name);
        updated[dimensionKey] = mergeDimensionFromPreview(existingDimensions?.[dimensionKey], dimension);
    }
    return updated;
};
